import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import bestPriceImage from '../../static/images/best-price-image.png';
import winCoinsImage from '../../static/images/win-coins-image.png';
import redeemCoinsImage from '../../static/images/redeem-coins-image.png';
import sandosLogo from '../../static/images/sandos4u-logo.png';
import { setShowLogin } from '../../actions/Loyalty';
import {
  DEVICES,
} from '../../actions/Booking';

import './BannerSandos4U.css';

const BannerSandos4U = (props, context) => {
  const onClickLogin = () => {
    props.dispatch(setShowLogin(true));
  };

  const renderText1 = () => {
    switch (props.lang) {
      case 'es':
        return (
          <div className="BannerS4U-text">
            <div className="BannerS4U-text-line1">Mejor Precio</div>
            <div className="BannerS4U-text-line1">Garantizado</div>
          </div>
        );
      case 'de':
        return (
          <div className="BannerS4U-text">
            <div className="BannerS4U-text-line1">Bester Preis</div>
            <div className="BannerS4U-text-line1">Garantie</div>
          </div>
        );
      case 'fr':
        return (
          <div className="BannerS4U-text">
            <div className="BannerS4U-text-line1">Meilleur</div>
            <div className="BannerS4U-text-line1">Prix Garanti</div>
          </div>
        );
      default:
        return (
          <div className="BannerS4U-text">
            <div className="BannerS4U-text-line1">Best Price</div>
            <div className="BannerS4U-text-line1">Guarantee</div>
          </div>
        );
    }
  };
  const renderText2 = () => {
    switch (props.lang) {
      case 'es':
        return (
          <div className="BannerS4U-text">
            <div className="BannerS4U-text-line1">Gana</div>
            <div className="BannerS4U-text-line1">Coins</div>
          </div>
        );
      case 'de':
        return (
          <div className="BannerS4U-text">
            <div className="BannerS4U-text-line1">Gewinne</div>
            <div className="BannerS4U-text-line1">Coins</div>
          </div>
        );
      case 'fr':
        return (
          <div className="BannerS4U-text">
            <div className="BannerS4U-text-line1">Gagne</div>
            <div className="BannerS4U-text-line1">Des Pièces</div>
          </div>
        );
      default:
        return (
          <div className="BannerS4U-text">
            <div className="BannerS4U-text-line1">Win</div>
            <div className="BannerS4U-text-line1">Coins</div>
          </div>
        );
    }
  };
  const renderText3 = () => {
    switch (props.lang) {
      case 'es':
        return (
          <div className="BannerS4U-text">
            <div className="BannerS4U-text-line1">Redime</div>
            <div className="BannerS4U-text-line1">Coins</div>
          </div>
        );
      case 'de':
        return (
          <div className="BannerS4U-text">
            <div className="BannerS4U-text-line1">Münzen</div>
            <div className="BannerS4U-text-line1">Einlösen</div>
          </div>
        );
      case 'fr':
        return (
          <div className="BannerS4U-text">
            <div className="BannerS4U-text-line1">Échangez</div>
            <div className="BannerS4U-text-line1">Vos Pièces</div>
          </div>
        );
      default:
        return (
          <div className="BannerS4U-text">
            <div className="BannerS4U-text-line1">Redeem</div>
            <div className="BannerS4U-text-line1">Coins</div>
          </div>
        );
    }
  };
  return (
    <div className="BannerS4U-container">
      <div className={`BannerS4U-left ${props.lang === 'fr'
        && props.isDesktop === true ? 'BannerS4U-left-adjust-large-text' : ''}`}>
        <div className="BannerS4U-title">{context.t('Sandos4u Benefits')}</div>

        <div className={`BannerS4U-benefits ${props.lang === 'fr'
          && props.isDesktop === true ? 'BannerS4U-benefits-adjust-large-text' : ''}`}>
          <div className="BannerS4U-benefit">
            <img src={bestPriceImage} alt="Best Price" className="BannerS4U-icon" />
            {renderText1()}
          </div>

          <div className="BannerS4U-benefit">
            <img src={winCoinsImage} style={{ width: '44px', height: '33px' }}
              alt="Win Coins" className="BannerS4U-icon" />
            {renderText2()}
          </div>

          <div className="BannerS4U-benefit">
            <img src={redeemCoinsImage} alt="Redeem Coins" className="BannerS4U-icon" />
            {renderText3()}
          </div>
        </div>
        {/* eslint-disable-next-line max-len */}
        <a href="https://www.sandos.com/es/sandos4u?_gl=1*hneqvr*_ga*OTYxNTMyODUwLjE3NTQzMjM5ODc.*_gcl_au*MTY3NzU5NDc3Ny4xNzU4NjU0NjM4" target='_blank' className="BannerS4U-learnmore" rel="noreferrer">{context.t('Learn More')}</a>
      </div>

      <div className="BannerS4U-right">
        <img src={sandosLogo} alt="Sandos4u Logo" className="BannerS4U-logo" />
        <button className="BannerS4U-button" onClick={() => onClickLogin()}>{context.t('Register Now')}</button>
      </div>
    </div>
  );
};

BannerSandos4U.propTypes = {
};

BannerSandos4U.contextTypes = {
  t: PropTypes.func.isRequired,
  router: PropTypes.object.isRequired,
};

export default connect((state) => ({
  lang: state.i18nState.lang,
  isDesktop: state.booking.device === DEVICES.DESKTOP,
  loyaltyName: state.session.chainData.loyalty_name,
  new_member_discount_percentage_activated: state.booking.hotel != null
    ? (state.booking.hotel.new_member_discount_percentage_activated === true
      && state.bookingFormState.agentSell === 'false') : false,
  new_member_discount_percentage_chain: state.booking.hotel !== null
    ? state.session.chainData.loyalty_levels
      .find((member) => (member.membership_name === (state.bookingFormState.agentCode !== '' ? 'Blue Agent' : 'Blue')))
      .new_member_discount_percentage_hotels[state.booking.hotel.code.toLowerCase()]
    : 0,
}))(BannerSandos4U);
